<template>
    <div class='content-wrapper inbox'>
       <div class='inbox-header'>
        <div class='inbox-nav'>
          <label style='margin-right:10px;'>搜索</label>
            <el-input class='input' placeholder="请输入消息主题" prefix-icon="el-icon-search" v-model="content"></el-input>
             <el-button  type="primary" @click="getList(content)">查询</el-button>
             <el-button   @click="content='';getList(content)">重置</el-button>
        </div>
       </div>
       <div class='section'>
           <div class='readbtn'>
                <el-button @click='markRead'>标为已读</el-button>
            </div>
           <div class='message_list_item head'>
            <span class='status'>
                <el-checkbox v-model="isChoosenAll" @change='changeChoosen'></el-checkbox>
            </span>
            <span class='theme'>消息主题</span>
            <span class='recipients'>发件人</span>
            <span class='delivery_date'>日期</span>
            <span class='accessory'>附件</span>
           </div>
            <div v-show='boxList.length === 0' class='message_list_item empty'>暂无数据</div>
          <div v-for='(item,index) in boxList' :key='index' class='message_list_item item' :class='{"islooked":item.isLook === 1}'>
            <span class='status'>
                <el-checkbox v-model="item.isChoosen"></el-checkbox>
            </span>
            <span class='theme cursor' @click='goDetail(item.messageID)' >{{item.title}}</span>
            <span class='recipients'>{{item.userName}}</span>
            <span class='delivery_date'>{{item.sendTime}}</span>
            <span class='accessory'><span v-if='item.attachment != 0' style='font-size:18px;' class='fa fa-paperclip'></span></span>
           </div>
            <div class='foot'>
            <el-pagination
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                @size-change='getSizeChange'
                @current-change='getPageChange'
                :page-size=10>
            </el-pagination>
        </div>
       </div>
       <el-dialog
        title="接收对象详情"
        :visible.sync="isShowDetailList"
        width="40%"
        :before-close="handleClose">
            <detail-list></detail-list>
        </el-dialog>
       
    </div>
</template>

<script>
// import ajax from './api/ajax.js'
// import config from './config/config.js'
//import detailList from '../../components/notice/detailList'
var config = {}
var ajax = {}

export default {
  data() {
    return {
      boxList: [],
      dialogVisible: false,
      content: '',
      isShowDetailList: false,
      total: 0,
      currentPage: 1,
      currentSize: 10,
      isChoosenAll: false
    }
  },
  components: {
    // detailList
  },
  props: {
    category: {
      type: String,
      default: 'all'
    },
    ajax: {
      type: Object
    },
    config: {
      type: Object
    }
  },
  watch: {
    category(val) {
      this.getList()
    }
  },
  methods: {
    getList(content) {
      var self = this
      let param = {}
      this.boxList = []
      // 1、搜索参数
      if (content !== undefined) {
        param.title = content
      }
      param.pageNum = this.currentPage
      param.pageSize = this.currentSize
      // param.types = this.category

      let url = ''
      if (this.category !== 'all') {
        url = `/?type=${this.category}`
      }

      ajax
        .post(config.host + 'infoflow/message/inbox/list/' + url, param)
        .then(function(res) {
          // console.log(res)
          if (res && res.success) {
            let list = res.body.list
            for (let i in list) {
              let obj = {}
              self.$set(obj, 'title', list[i].title)
              let temp = list[i].userName.split(',', 4)
              list[i].userName = ''
              for (let j = 0; j < temp.length; j++) {
                if (j < 3 && j !== temp.length - 1) {
                  list[i].userName += temp[j] + ','
                } else if (j < 3 && j === temp.length - 1) {
                  list[i].userName += temp[j]
                } else {
                  list[i].userName += temp[j] + '...'
                }
              }

              self.$set(obj, 'userName', list[i].userName)
              self.$set(obj, 'sendTime', list[i].sendTime)
              self.$set(obj, 'attachment', list[i].attachment)
              self.$set(obj, 'status', list[i].status)
              self.$set(obj, 'isLook', list[i].isLook)
              self.$set(obj, 'messageID', list[i].messageID)
              self.$set(obj, 'isChoosen', false)
              self.$set(self.boxList, i, obj)
            }
            let page = res.body.page

            self.total = page.total
          }
        })
    },
    handleClose() {},
    showDetailList(id) {
      this.isShowDetailList = true
    },
    goDetail(id) {
      // this.$router.push({ path: 'detail', query: { id: id, type: 'inbox' } })
      this.$emit('detail', { status: 'outbox_detail', id: id, type: 'inbox' })
    },
    changeChoosen() {
      for (let i in this.boxList) {
        this.boxList[i].isChoosen = this.isChoosenAll
      }
    },
    markRead() {
      let msgIDs = ''
      for (let i in this.boxList) {
        if (this.boxList[i].isChoosen) {
          msgIDs += this.boxList[i].messageID + ','
        }
      }
      let self = this
      if (msgIDs !== '') {
        ajax
          .post(`${config.host}infoflow/message/inbox/${msgIDs}/markRead`)
          .then(function(res) {
            self.isChoosenAll = false
            self.getList()
          })
      }
    },
    getPageChange(e) {
      this.currentPage = e
      this.getList()
    },
    getSizeChange(e) {
      this.currentSize = e
      this.getList()
    }
  },
  created() {
    ajax = this.ajax
    config = this.config
    this.getList()
  }
}
</script>


<style scoped>
.content-wrapper {
  width: 100%;
}
.inbox {
  background-color: #ffffff;
  display: block;
  padding: 0px;
}
.inbox .inbox-header {
  padding-top: 10px;
  border-bottom: 1px solid #f5f5f5;
}
.inbox .inbox-nav {
  margin-bottom: 20px;
  padding-left: 20px;
}
.inbox .inbox-nav .input {
  width: 250px;
  margin-right: 10px;
}
.inbox .section {
  width: 98%;
  margin-left: 10px;
  margin-top: 10px;
}
.inbox .section .readbtn {
  margin-left: 10px;
  margin-bottom: 10px;
}
.message_list_item {
  min-height: 60px;
  display: flex;
  align-items: center;
}
.message_list_item.empty {
  justify-content: center;
  border: 1px solid #f5f5f5;
}
.message_list_item.item.islooked {
  color: #aaa;
}
.message_list_item.head {
  background-color: #f5f5f5;
}
.message_list_item .theme {
  display: inline-block;
  overflow-x: hidden;
  width: 30%;
}
.message_list_item .recipients {
  display: inline-block;
  width: 25%;
}
.message_list_item .delivery_date {
  display: inline-block;
  width: 25%;
}
.message_list_item .accessory {
  display: inline-block;
  width: 15%;
}
.message_list_item .status {
  display: inline-block;
  width: 150px;
  text-align: center;
}
.message_list_item.item {
  border-bottom: 1px solid #f5f5f5;
}
.inbox .foot {
  position: relative;
  top: 10px;
}
.cursor {
  cursor: pointer;
}
.cursor:hover {
  color: #3c8dbc;
}
</style>



// WEBPACK FOOTER //
// node_modules/mywayinfo-message-components/src/inbox.vue